var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsiteEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8759 12.9612C23.8218 12.0153 25.3319 11.9775 26.3229 12.8477L26.444 12.9612L27.0387 13.5559C27.9846 14.5018 28.0225 16.0119 27.1522 17.0029L27.0387 17.124L17.609 26.5538C17.4752 26.6875 17.3136 26.789 17.1363 26.8515L17.0006 26.8909L13.254 27.7556C12.6797 27.8881 12.1618 27.4075 12.2279 26.8411L12.2444 26.746L13.109 22.9993C13.1515 22.815 13.2348 22.6433 13.352 22.4963L13.4462 22.391L22.8759 12.9612ZM22.2812 15.9347L14.7208 23.4951L14.1856 25.8144L16.5049 25.2791L24.0652 17.7188L22.2812 15.9347ZM25.2547 14.1506C24.9515 13.8474 24.4744 13.8241 24.1445 14.0806L24.0653 14.1506L23.4705 14.7453L25.2546 16.5294L25.8494 15.9347C26.1525 15.6315 26.1758 15.1544 25.9193 14.8245L25.8494 14.7453L25.2547 14.1506Z",
    fill: "#21272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteEditIcon);
export default __webpack_public_path__ + "static/media/website-edit-icon.3b65de362ff03ec107ea886f92119854.svg";
export { ForwardRef as ReactComponent };